export default __webpack_public_path__ + "static/media/auditorium_with_rows_preview.f4972386.png";